import React from "react";
import {
    Box,
    Paper,
    Stack,
    SxProps,
    Theme,
    useMediaQuery,
    useTheme,
} from "@mui/material";

export type ResponsiveDetailLayoutProps = {
    header: React.ReactNode;
    primaryMedia?: React.ReactNode;
    primaryDetails: React.ReactNode;
    secondaryContent?: React.ReactNode;

    spacing?: number;
    mobileOnly?: boolean;
    wrapSectionsInPaper?: boolean;

    containerSx?: SxProps<Theme>;
    headerSx?: SxProps<Theme>;
    primaryMediaSx?: SxProps<Theme>;
    primaryDetailsSx?: SxProps<Theme>;
    secondaryContentSx?: SxProps<Theme>;
};

const ResponsiveDetailLayout: React.FC<ResponsiveDetailLayoutProps> = ({
    header,
    primaryMedia,
    primaryDetails,
    secondaryContent,
    spacing = 2,
    mobileOnly = true,
    wrapSectionsInPaper = false,
    containerSx,
    headerSx,
    primaryMediaSx,
    primaryDetailsSx,
    secondaryContentSx,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const wrap = (content: React.ReactNode, sx?: SxProps<Theme>) => {
        if (!wrapSectionsInPaper) {
            return <Box sx={sx}>{content}</Box>;
        }

        return (
            <Paper
                elevation={1}
                sx={{
                    p: 2,
                    borderRadius: 2,
                    ...sx,
                }}
            >
                {content}
            </Paper>
        );
    };

    if (mobileOnly && !isMobile) {
        return (
            <>
                {wrap(header, headerSx)}
                {wrap(primaryDetails, primaryDetailsSx)}
                {primaryMedia && wrap(primaryMedia, primaryMediaSx)}
                {secondaryContent && wrap(secondaryContent, secondaryContentSx)}
            </>
        );
    }

    return (
        <Stack
            spacing={spacing}
            sx={{
                width: "100%",
                ...containerSx,
            }}
        >
            {wrap(header, headerSx)}
            {wrap(primaryDetails, primaryDetailsSx)}
            {primaryMedia && wrap(primaryMedia, primaryMediaSx)}
            {secondaryContent && wrap(secondaryContent, secondaryContentSx)}
        </Stack>
    );
};

export default ResponsiveDetailLayout;